<template>
  <div :class="'col-md-' + col" class="custom-checkbox" :style="{'margin': marginCustom}">
    <label>
      <input class="custom-checkbox-input" type="checkbox" v-model="valueCheckbox">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: "inputCheckbox",
  props: {
    label: {
      required: true,
    },
    col: {
      required: true,
    },
    isChecked: {
      default: false,
    },
    marginCustom: {
      default: ''
    }
  },
  data() {
    return {
      valueCheckbox: this.isChecked,
    }
  },
  watch: {
    valueCheckbox(newValue, oldValue) {
      this.$emit('valueCheckbox', newValue)
    }
  }
}
</script>

<style lang="scss" scoped>

.custom-checkbox {
  label {
    margin-bottom: 20px;
    display: flex;
    font-weight: 400;
    font-size: 13px;
    color: #3A424E;
    cursor: pointer;
    width: max-content;

    input[type=checkbox] {
      margin: 0 8px 0 0;
      -webkit-appearance: none;
      appearance: none;
      width: 20px;
      height: 20px;
      background-color: #FFFFFF;
      border: 0.5px solid #BACADC;
      border-radius: 2px !important;
      cursor: pointer;
      transition: .2s;
      position: relative;
      z-index: 1;

      &:checked {
        background-color: #2F23D6;
        border: #2F23D6;

        &:before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-family: FontAwesome;
          content: "\f00c";
          color: #FFFFFF;
          font-size: 12px;
        }
      }

      &:focus {
        outline: none;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputCheckbox.vue